import React, { useContext, useEffect } from 'react'
import AddBeneficiaries from '../Components/AddBeneficiary';
import { Context } from '../Context/Context';

const Beneficiary = ({ UserBeneficiaryDetails, verified, NumberOfBeneficiaryAcct }) => {

    const {
        viewDetails,
        profileEdit,
        deleteProfile,
        beneficiaryBar,
        sendBarFromBeneficiary,
        sideBar,
        loadingBen,
        fetchBeneficiaries
    } = useContext(Context)

    useEffect(() => {
        if (viewDetails || profileEdit || deleteProfile || sideBar || beneficiaryBar || sendBarFromBeneficiary) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [viewDetails, profileEdit, deleteProfile, sideBar, beneficiaryBar, sendBarFromBeneficiary])

    return <AddBeneficiaries verified={verified} getBeneficiaries={fetchBeneficiaries} loadingBen={loadingBen} UserBeneficiaryDetails={UserBeneficiaryDetails} NumberOfBeneficiaryAcct={NumberOfBeneficiaryAcct} />;
}

export default Beneficiary